import React, { useState } from 'react';
import Select from 'react-select';
import { Table } from "antd";

const MainTab = () => {

    const columns = [
        { title: "AWB No.", dataIndex: "SNo", key: "SNo" },
        { title: "Status", dataIndex: "action", key: "action" },
        { title: "Consol/Job Order", dataIndex: "TrackingURL", key: "TrackingURL" },
        { title: "Details", dataIndex: "HomepageURL", key: "HomepageURL" },
        { title: "Remark", dataIndex: "NVOCC", key: "NVOCC" },
    ];

    const dataSource = [
        {
            key: "", // Add a unique key for each row
            SNo: "", // Changed to camelCase
           
        },
    ]

    return (
        <>
            <div className="row border-bottom-2 card m-1">
                <div className="col-md-12 card-body">
                <div className="d-flex align-items-end justify-content-between flex-wrap row-gap-2 mb-3">
                                <div className="d-flex align-items-center flex-wrap row-gap-2">
                                    <div className="row">

                                        <div className="col-md-6">
                                            <div className="d-flex justify-content-between">
                                                <div className='d-flex align-items-baseline'>
                                                    <label htmlFor="" className='form-label mb-0'>
                                                    Is Neutral	

                                                    </label>
                                                    <div className="icon-forms ms-2">
                                                        <input
                                                            type="checkbox"
                                                        />
                                                    </div>
                                                </div>
                                                <div className=' '>
                                                    <label htmlFor="" className='form-label  mb-0'>
                                                    Issued At
                                                    </label>
                                                    <div className="icon-forms mb-3 mb-sm-0">
                                                    <Select
                                                        className='custom-selector '
                                                        name="role_id"
                                                    />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className=' '>
                                                <label htmlFor="" className='form-label  mb-0'>
                                                Received From
                                                </label>
                                                <div className="icon-forms mb-3 mb-sm-0">
                                                <Select
                                                        className='custom-selector '
                                                        name="role_id"
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            <div className=' '>
                                                <label htmlFor="" className='form-label  mb-0'>
                                                GSA
                                                </label>
                                                <div className="icon-forms mb-3 mb-sm-0">
                                                <Select
                                                        className='custom-selector '
                                                        name="role_id"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className=' '>
                                                <label htmlFor="" className='form-label  mb-0'>
                                                Commision
                                                </label>
                                                <div className="icon-forms mb-3 mb-sm-0">
                                                <input
                                                            type="text"
                                                            className="form-control form-control-sm"
                                                            name='search_by'
                                                        />
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <h6>List of AirWay Bills</h6>
                            <div className="table-responsive custom-table">
                                <Table className="table datanew dataTable no-footer" pagination={false}
                                    dataSource={dataSource} columns={columns} />
                            </div>
                            <div className="row mt-2">
                                
                            <div className="col-md-6">
                                            <div className=' '>
                                                <label htmlFor="" className='form-label  mb-0'>
                                                Current Status
                                                </label>
                                                <div className="icon-forms mb-3 mb-sm-0">
                                                <input
                                                            type="text"
                                                            className="form-control form-control-sm"
                                                            name='search_by'
                                                        />
                                                </div>
                                            </div>
                                        </div>
                            <div className="col-md-6">
                                            <div className=' '>
                                                <label htmlFor="" className='form-label  mb-0'>
                                                New Status	
                                                </label>
                                                <div className="icon-forms mb-3 mb-sm-0">
                                                <Select
                                                        className='custom-selector '
                                                        name="role_id"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        
                                        <div className="col-md-6">
                                            <div className=' '>
                                                <label htmlFor="" className='form-label  mb-0'>
                                                Date
                                                </label>
                                                <div className="icon-forms mb-3 mb-sm-0">
                                                <input
                                                            type="date"
                                                            className="form-control form-control-sm"
                                                            name='search_by'
                                                        />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className=' '>
                                                <label htmlFor="" className='form-label  mb-0'>
                                                Remark
                                                </label>
                                                <div className="icon-forms mb-3 mb-sm-0">
                                                <input
                                                            type="text"
                                                            className="form-control form-control-sm"
                                                            name='search_by'
                                                        />
                                                </div>
                                            </div>
                                        </div>
                            </div>
                    
                <div className="d-flex flex-wrap gap-2 mt-2 pb-2" style={{ borderBottom: '1px solid #d4d4d4' }}>
                    <button className="btn btn-primary text-xs" type="button">
                        Edit
                    </button>
                    <button className="btn btn-primary text-xs" type="button">
                        Update
                    </button>
                    <button className="btn btn-primary text-xs" type="button">
                        Cancel
                    </button>
                    <button className="btn btn-primary text-xs" type="button">
                        Allot AWB 
                    </button>
                </div>
                </div>
            </div>

        </>
    );
};

export default MainTab
